
export default class kasher {
  constructor() {
    var kshRaf;
    var kshRunTime = 0;
    var ltrIterations = 7;
    var kashed = [];

    /*
    var ltrRepo = "!#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[]^_`abcdefghijklmnopqrstuvwxyz{|}~€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþ†‡•‣‹›※‽⁁⁂⁃⁄⁅⁆⁇⁈⁊⁋⁌⁍⁎⁏⁐⁑₠₡₢₣₤₥₦₧₨₩₪₫€₭₮₯₰₱₲₳₴₵℀℁ℂ℃℄℅℆ℇ℈℉ℊℋℌℍℎℏℐℑℒℓ℔ℕ№℗℘ℙℚℛℜℝ℞℟℠℡℣ℤ℥Ω℧ℨ℩KÅℬℭ℮ℯℰℱℲℳℴℵℶℷℸ℺℻ℼℽℾℿ⅀⅁⅂⅃⅄ⅅⅆⅇⅈⅉ⅊⅋⅌⅍ⅎ⅏ΑΒΓΔΕΖΝΞΟΠΡ΢ΣΤΥΦΧΨΩΪΫάέήίΰαεζηθικλμνξοπρςστυφχψω⅐⅑⅒⅓⅔⅕⅖⅗⅘⅙⅚⅛⅜⅝⅞⅟ↀↁↂↃↄↅↆ↉⤧⤨⤩⤪⤫⤬⤭⤮⤯⤰⤱⤲⤳∀∁∂∃∄∅∆∇∈∉∊∋∌∍∎∏∐∑−∓∔∕∖∗∘∙√∛∜∝∞∟∠∡∢∣∤∥∦∧∨∩∪∫∬∭∮∯∰∱∲∳∸∹∺∻∼∽∾∿≀≁≂≃≄≅≆≇≈≉≊≋≌≍≎≏≐≑≒≓≔≕≖≗≘≙≚≛≜≝≞≟≠≡≢≣≤≥≦≧≨≩≪≫≬≭≮≯≰≱≲≳≴≵≶≷≸≹≺≻≼≽≾≿⊀⊁⊂⊃⊄⊅⊆⊇⊈⊉⊊⊋⊌⊍⊎⊏⊐⊑⊒⊓⊔⊕⊖⊗⊘⊙⊚⊛⊜⊝⊞⊟⊠⊡⊢⊣⊤⊥⊦⊧⊨⊩⊪⊫⊬⊭⊮⊯⊰⊱⊲⊳⊴⊵⊶⊷⊸⊹⊺⊻⊼⊽⊾⊿⋀⋁⋂⋃⋄⋅⋆⋇⋈⋉⋊⋋⋌⋍⋎⋏⋐⋑⋒⋓⋔⋕⋖⋗⋘⋙⋚⋛⋜⋝⋞⋟⋠⋡⋢⋣⋤⋥⋦⋧⋨⋩⋪⋫⋬⋭⋮⋯⋰⋱⋲⋳⋴⋵⋶⋷⋸⋹⋺⋻⋼⋽⋾⋿⟀⟁⟂⟃⟄⟅⟆⟇⟈⟉⟊⟋⟌⟍⟎⟠⟨⟩⧫⧬⧭⧮⧯⧰⧱⧲⧳⧴⧵⧶⧷⧸⧹⧺⧻⧼⧽⧾⧿⨀⨁⨂⨃⨄⨅⨆⨇⨈⨉⨊⨋⨌⨍⨎⨏⨐⨑⨒⨓⨔⨕⨖⨗⨘⨙⨚⨛⨜⨝⨞⨟⨠⨡⨢⨣⨤⨥⨦⨧⨨⨩⨪⨫⨬⨭⨮⨯⨰⨱⨲⨳⨴⨵⨶⨷⨸⨹⨺⨻⨼⨽⨾⨿⩀⩁⩂⩃⩄⩅⩆⩇⩈⩉⩊⩋⩌⩍⩎⩏⩐⩑⩒⩓⩔⩕⩖⩗⩘⩙⩚⩛⩜⩝⩞⩟⩠⩡⩢⩣⩤⩥⩦⩧⩨⩩⩪⩫⩬⩭⩮⩯⩰⩱⩲⩳⩴⩵⩶⩷⩸⩹⩺⩻⩼⩽⩾⩿⪀⪁⪂⪃⪄⪅⪆⪇⪈⪉⪊⪋⪌⪍⪎⪏⪐⪑⪒⪓⪔⪕⫷⫸⫹⫺⫻⫼⫽⌗⌘⌙⌜⌝⌞⌟⌠⌡⌥⌦⌧⌫⌬⌷⌸⌹⌺⌻⌼⌽⌾⍁⍂⍃⍄⍅⍆⍇⍈⍉⍊⍋⍌⍍⍎⍏⍐⍑⍒⍓⍔⍕⍖⍗⍘⍙⍚⍛⍜⍝⍞⍟⍠⍡⍢⍣⍤⍥⍦⍧⍨⍩⍪⍫⍬⍭⍮⍯⍰⍱⍲⍳⍴⍵⍶⍷⍸⍹⍺⍻⍼⏢⏣⏤⏥⏦⏧␣①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵ⒶⒷⒸⒹⒺⒻⒼⒽⒾⒿⓀⓁⓃⓄⓅⓆⓇⓈⓉⓊⓋⓌⓍⓎⓏⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ⓪⓫⓬⓭⓮⓯⓰⓱⓲⓳⓴⓵⓶⓷⓸⓹⓺⓻⓼⓽⓾⓿▇█▉▊▋▌▍▎▏▐░▒▓▔▕▖▗▘▙▚▛▜▝▞▟■□▢▣▤▥▦▧▨▩▬▭▮▯▰▱▲△▴▵▷▸▹►▻▼▽▾▿◁◂◃◄◅◆◇◈◉◊○◌◍◎●◐◑◒◓◔◕◖◗◘◙◚◛◠◡◢◣◤◥◦◧◨◩◪◫◬◭◮◯◰◱◲◳◴◵◶◷◸◹◺◿☇☈☉☊☋☌☍☏☒☓☖☗☙☚☛☜☞☟☡☤☥☧☨☩☫☬☭☰☲☳☴☵☶☷☻☼☽☾☿♁♃♄♅♆♇♔♚♛♜♝♞♩♪♫♬♭⚆⚇⚈⚉⚐⚑⚘⚚⚢⚣⚤⚥⚦⚨⚩⚬⚭⚮⚯⚲✁✃✄✆✇✎✐✑✓✕✗✘✙✚✛✜✞✟✠✢✣✤✥✦✧✩✪✫✬✭✮✯✰✱✲✵✶✷✸✹✺✻✼✽✾✿❀❁❂❃❅❆❈❉❊❋❍❘❙❚❛❜❝❞❡❢❥❦❧❨❩❪❫❬❭❮❯❰❱❲❳❴❵❶❷❸❹❺❻❼❽❾❿➀➁➂➃➄➅➆➇➈➉➊➋➌➍➎➏➐➑➒➓➔➘➙➚➛➜➝➞➟➠➢➣➤➥➦➧➨➩➪➫➬➭➮➯➱➲➳➴➵➶➷➸➹➺➻➼➽➾⬈⬉⬊⬋⬌⬍⬎⬏⬐⬑⬒⬓⬔⬕⬖⬗⬘⬙⬚⬝⬞⬟⬠⬡⬢⬣⬤⬥⬦⬧⬨⬩⬪⬫⬬⬭⬮⬯⬰⬱⬲⬳⬴⬵⬶⬷⬸⬹⬺⬻⬼⬽⬾⬿⭀⭁⭂⭃⭄⭅⭆⭇⭈⭉⭊⭋⭌⭑⭒⭓⭔";
    */

    var ltrRepo = "!#$%&()/§{}[]@0X+-_";

    var ltrRepoLen =ltrRepo.split("").length;

    function kasher() {
      var i = kashed.length;
      while(i--){
        var k = kashed[i];
        var iters = k.iterations;
        if(k.delay+k.start < kshRunTime && kshRunTime < k.delay+k.start+iters){
          k.el.addClass('sh');
          var r = rndltr();
          k.el.text(r);
        } else if (kshRunTime >= k.delay+k.start+ltrIterations){
          k.el.addClass('sh');
          k.el.text(k.ltr);
          kashed.splice(i,1);
          if(k.last){
            k.el.parents('.kash').removeClass('kashing');
            k.el.parents('.kash').addClass('once-kashed');
            /*
            if(k.el.parents('.kash').attr('data-ite')){
            k.el.parents('.kash').removeAttr('data-ite');
          }
          */

          if($(k.el).parents('#menu').length>0){
            $(k.el).parents('a').addClass('ok');
          }

          if($(k.el).parents('.kash').hasClass('tag')){
            $(k.el).parents('.kash').css({
              'max-width' : '',
            });
            setTimeout(function(){
              // console.log('setting maxwidth');
              $(k.el).parents('.kash').css({
                // 'max-width' : $(k.el).parents('.kash').width(),
              });
            }, 30);
          }
        }
        //$(k.el).removeAttr('style').css('width',$(k.el).outerWidth());
        //$(k.el).css('width','auto').css('width',$(k.el).outerWidth());
      } else {
        // console.log(k);
      }
      //} else {
      //  k.el.parents('.kash').removeClass('kashing');
      //  k.delay = kshRunTime;
      //}
    }
    // console.log(kshRunTime,kashed);
    kshRunTime += 1.5;
    kshRaf = window.requestAnimationFrame(kasher);
  }

  var lettersResizeTimeout;

  function initKash(){
    console.log('inited kash');

    var initKashIDX = 1;

    $('.ktxt').not('.ktxtnav').each(function(idx){
      //    console.log(idx);
      $(this).spanify();
      if(!$(this).hasClass('kscroll')){
        $(this).kashify((initKashIDX*0.5)*idx);
        initKashIDX++;
      } else {
        // $(this).kashify(idx);
      }
    });

    $('.kchild').each(function(idx){
      $(this).children().not('figure').each(function(){
        $(this).spanify();
      });
      if($(this).hasClass('kchild')){
        if($(this).get(0).getBoundingClientRect().top < window.innerHeight){
          var dly = Math.min(30,initKashIDX);
          if(!$(this).hasClass('kscroll')){
            $(this).kashify((dly*0.5) + idx);
            initKashIDX++;
          } else {
            $(this).kashify(idx);
          }
        }
      }
    });

    $('.kchildlater').each(function(){
      $(this).find('p').each(function(){ $(this).spanify(); });
    });
    $('.kchildlater .sp').addClass('kash');

    $('.ktxtnav').each(function(idx){
      $(this).spanify();
      $(this).kashify(idx*2);
    });

    $('.contact-block').addClass('peek');
    $('.kchildlater .sp .l').each(function(){
      // $(this).css('width',$(this).outerWidth());
    });

    /*
    if($('#index').hasClass('list')){

      $('.kchildinstant').each(function(idx){
      $(this).children().not('figure').each(function(){
      $(this).spanify();
      });
      $(this).kashify(idx*0.2);
    });

    $('.ktxtindex').each(function(idx){
    $(this).children().not('figure').each(function(){
    $(this).spanify();
    });
    $(this).attr('data-ite',4);
    });

    $('.link.ktxtindex').each(function(idx){
    var t = $(this)
    setTimeout(function(){
    $(t).addClass('once-kashed');
    },10*idx + 50);
    $(this).find('.l').removeClass('hd').addClass('sh');

    });
    }
    */

    
    // if($('body').hasClass('experts')){
    //   $(window).scroll(function(){
    //     var rajaTop =  window.innerWidth>600 ? 0 :  window.innerHeight*0.1;
    //     var rajaBtm =  window.innerWidth>600 ?  window.innerHeight :  window.innerHeight*0.9;
    //     $('.expert-tile .kash:not(.kashing)').each(function(){
    //       var rect = $(this).get(0).getBoundingClientRect();
    //       if(rect.top < rajaBtm && rect.bottom > rajaTop){
    //         if(!$(this).hasClass('kashing') && !$(this).hasClass('in')){
    //           $(this).kashify();
    //           $(this).addClass('in');
    //         }
    //       } else {
    //         if(rect.top >  window.innerHeight||rect.bottom<0){
    //           $(this).removeClass('in');
    //         }
    //       }
    //     });
    //   });
    // } else {
      $(window).scroll(function(){
        $('.kscroll').each(function(){
          var rect = $(this).get(0).getBoundingClientRect();
          if(rect.top <  window.innerHeight && rect.bottom > 0){
            if(!$(this).hasClass('kashing') && !$(this).hasClass('in')){
              $(this).kashify();
              $(this).addClass('in');
            }
          } else {
            $(this).removeClass('in');
          }
        });
      });
    // }
    

    $('.ktxt, .kchildinstant').mouseenter(function(){
      if(!MOBILE){
        $(this).kashify();
      }
    });

    $('.ktxtindex').mouseenter(function(){
      if(!MOBILE){
        var exKashed = kashed;
        kashed = [];
        for(var i=0;i<exKashed.length;i++){
          if($(exKashed[i].el).parents('.ktxtindex').length>0){
            $(exKashed[i].el).text(exKashed[i].ltr).addClass('sh');
          } else {
            kashed.push(exKashed[i]);
          }
        }
        $('.ktxtindex.kashing').removeClass('kashing').addClass('once-kashed');
        //$('.once-kashed .l').each(function(){ $(this).text($(this).text());});
        $(this).kashify();
      }
    });

    $(window).trigger('scroll');

    $(window).resize(function(){
      clearTimeout(lettersResizeTimeout);
      lettersResizeTimeout = setTimeout(function(){

        $(".l").each(function(){
          $(this).css('width','auto').css('width',$(this).outerWidth());
        });

        $('.kash:not(.kashing)').each(function(){
          // $(this).css('min-height','');
          $(this).css('min-width','');
          $(this).css('max-width','');
        });
        $('.ktxtnav, .ktxtindex, .tag.kash').each(function(){
          $(this).css('min-width','');
          $(this).css('max-width','');
        });

        setTimeout(function(){
          $('.kash:not(.kashing)').each(function(){
            // $(this).css('min-height',$(this).height());
          });
          $('.ktxtnav, .ktxtindex, .tag.kash').each(function(){
            $(this).css('min-width',$(this).width());
            $(this).css('max-width',$(this).width());
          });
        },30);

      }, 300);
    });

    kasher();

    }

    $.fn.kashify = function(totaltime=kshRunTime) {
      if(!this.hasClass('kashing')){
        this.addClass('kashing');

        if($(this).hasClass('kwidth')) {
          $(this).css({
            'min-width' : $(this).width(),
            'max-width' : $(this).width(),
            // 'min-height' : $(this).height()
          });
        }

        var ltrsLength = $(this).find('.w .l').length;
        //    console.log("ltrsLength",ltrsLength);
        var ltridx = 0;
        let iterations = parseInt($(this).attr('data-ite'))||parseInt($(this).parents().attr('data-ite'))||ltrIterations;
        $(this).find('.w .l').each(function(){
          $(this).removeClass('sh');
          var t = $(this);
          totaltime += 1;
          var start = totaltime;
          var isLast = ltridx == ltrsLength-1;
          //      console.log(isLast);
          // console.log(iterations);
          t.addtokashed(start, isLast, iterations);
          ltridx++;
        });
      }
    }

    $.fn.addtokashed = function(delay, last, iterations) {
      var kashltr = {
        'el' : this,
        'ltr' : $(this).attr('data-orig')||this.text(),
        'delay' : 0,
        'start' : delay,
        'last' : last,
        'iterations' : iterations||ltrIterations,
      }
      kashed.push(kashltr);
    }

    $.fn.spanify = function() {
      if($(this).hasClass('sp')){
        return false;
      }
      var link = false;
      if($(this).find('a').length>0){
        link = $(this).find('a');
      }
      $(this).text($(this).text().trim());
      var words = $(this).text().split(' ');
      var wordsLen = words.length;
      var wordArray = [];
      for (var i = 0; i < wordsLen; i++) {
        let letters = words[i].split('');
        let ltrsLen = letters.length;
        let spanletters = [];
        for (var l = 0; l < ltrsLen; l++) {
          spanletters[l] = '<span class="l hd" data-orig="'+letters[l]+'">'+letters[l]+'</span>';
        }
        spanletters = spanletters.join('');
        wordArray[i] = '<span class="w">'+spanletters+'</span>';
      }
      if(!link){
        this.html(wordArray.join(' '));
      } else {
        var href = link.attr('href');
        var linkHtml = "<a href='"+href+"'>"+wordArray.join(' ')+"</a>";
        this.html(linkHtml);
      }
      this.addClass('sp');

      $(this).find('l').each(function(){
        $(this).css('max-width', $(this).outerWidth());
      });

      return this;
    }

    function rndltr() {
      return ltrRepo.charAt(Math.floor(Math.random() * ltrRepoLen));
    }

    initKash();

    }
}
